import { IconArrowRight } from "@tabler/icons-react";
import { HotkeyBadge } from "./shared";

type AssociationFooterProps = {
  onConfirmAssociation: () => void;
  onProductNotListed: () => void;
  isConfirmAssociationDisabled: boolean;
  /** True while an answer is being sent or the task released, so neither can happen twice. */
  isLocked: boolean;
};

export const AssociationFooter = ({
  onConfirmAssociation,
  onProductNotListed,
  isConfirmAssociationDisabled,
  isLocked,
}: AssociationFooterProps) => {
  return (
    <div className="flex shrink-0 items-center justify-end border-t border-[#E6EBEF] px-3 pt-4 animate-[slideUp_0.4s_ease-out_forwards]">
      <div className="flex items-center gap-3">
        <button
          onClick={onProductNotListed}
          disabled={isLocked}
          className="relative flex items-center justify-center gap-2 rounded-xl border border-[#E2E8F0] bg-white px-6 py-[14px] text-[#64748b] transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <HotkeyBadge hotkey="S" />
          <span className="mt-0.5 text-[12px] font-bold uppercase tracking-[0.12em]">
            Skip
          </span>
        </button>

        <button
          onClick={onConfirmAssociation}
          disabled={isConfirmAssociationDisabled || isLocked}
          className="relative flex items-center gap-3 rounded-xl bg-[#5A6EFA] px-7 py-[14px] text-white shadow-sm transition-all hover:bg-[#4d5ee6] focus:outline-none focus:ring-2 focus:ring-[#5A6EFA] focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400 disabled:shadow-none"
        >
          <HotkeyBadge hotkey="Space" className="text-[#5A6EFA]" />
          <span className="mt-0.5 text-[12px] font-bold uppercase tracking-[0.12em]">
            Confirm Association
          </span>
          <IconArrowRight size={18} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};
